import React, { useRef } from "react";
import {
  defaultLayouts,
  defaultPadding,
  GSLoadingSpinnerOverlay,
} from "golfstatus_react_components";
import { useSelector } from "react-redux";
import { selectTVLeaderboards } from "../../../../reducers/leaderboardSlice";
import TournamentTVLeaderboardControls from "./tournament-tv-leaderboard-controls";
import "./tournament-tv-leaderboards.scss";
import TVLeaderboardsWidget from "../../../widgets/tv-leaderboards-widget";
import TVLeaderboardsSponsorsWidget from "../../../widgets/tv-leaderboards-sponsors-widget";
import { useLoading } from "../../../../hooks/tournamentHooks";

const TournamentTVLeaderboards = () => {
  const leaderboards = useSelector(selectTVLeaderboards);

  const page = useRef(null);
  const scrollContent = useRef(null);
  const currentPage = page?.current;
  const currentContent = scrollContent?.current;

  const [isLoading] = useLoading([
    "getPublicLeaderboards",
    "getLeaderboardFlights",
    "getPublicTournamentDetails",
  ]);

  const getSpinner = () => {
    return (
      <div
        style={{
          ...defaultLayouts.fill,
          ...defaultLayouts.vStack.align("center", "center"),
          ...defaultPadding.emptyListPad,
        }}
      >
        <GSLoadingSpinnerOverlay mainText="Loading Leaderboards..." />
      </div>
    );
  };

  const getContent = () => {
    return (
      <>
        <TVLeaderboardsSponsorsWidget />
        <div
          ref={page}
          className="page"
          style={{
            ...defaultLayouts.fill,
            ...defaultLayouts.vStack,
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div ref={scrollContent} className="scroll-content">
            {isLoading ? getSpinner() : <TVLeaderboardsWidget />}
          </div>
        </div>

        <TournamentTVLeaderboardControls
          style={{ ...defaultLayouts.fullWidth }}
          currentPage={currentPage}
          currentContent={currentContent}
          ids={leaderboards?.map?.((l) => {
            return { id: l.id, title: l.name };
          })}
        />
      </>
    );
  };

  return (
    <tournament-tv-leaderboards
      style={{
        ...defaultLayouts.fill,
        position: "relative",
        overflowY: "hidden",
      }}
    >
      {getContent()}
    </tournament-tv-leaderboards>
  );
};

export default TournamentTVLeaderboards;
